// extracted by mini-css-extract-plugin
export var darkThemeLinks = "formatted-text-module--darkThemeLinks--es8-t";
export var deepLinkSubject = "formatted-text-module--deepLinkSubject--UMQYE";
export var lightThemeLinks = "formatted-text-module--lightThemeLinks--AEyAH";